import { useQuery } from "@tanstack/react-query";

import { useAuthenticated } from "../auth/SessionProvider";
import { post } from "./client";
import type { ProctorSiteResponse } from "./types";

/** One site's live status for the proctor screen; refreshed every 15 s. */
export function useProctorSite(siteId: number | undefined, enabled = true) {
  const { token } = useAuthenticated();
  return useQuery({
    queryKey: ["proctor-site", token, siteId ?? null],
    queryFn: () => post<ProctorSiteResponse>("/proctor/site", siteId === undefined ? {} : { siteId }, token),
    refetchInterval: 15_000,
    enabled
  });
}
